import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import routes from './routes.jsx';
import NotFound from './pages/NotFound';

// Percorsi del gruppo Health & Wellbeing (incluso hub /sanita)
const HEALTH_PATHS = new Set(
  routes
    .filter(r => r.group === 'health' || r.path === '/sanita')
    .map(r => r.path)
);

function TitleUpdater() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === '/') {
      document.title = 'EUROPROJECT CONSULTING';
      return;
    }
    const match = routes.find((r) => r.path === pathname);
    const pageName = match?.name ?? '';
    if (HEALTH_PATHS.has(pathname)) {
      document.title = pageName ? `Echos — ${pageName}` : 'Echos';
    } else {
      document.title = pageName ? `Europroject — ${pageName}` : 'Europroject Consulting';
    }
  }, [pathname]);
  return null;
}

const PageLoader = () => (
  <div
    className="flex items-center justify-center"
    style={{ minHeight: 'calc(100vh - 80px)' }}
  >
    <div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <Router>
      <TitleUpdater />
      <ScrollToTop />
      <div className="flex flex-col min-h-screen font-sans text-neutral-gray-800 antialiased">
        <Navbar />
        <main className="flex-grow" style={{ minHeight: 'calc(100vh - 80px)' }}>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              {routes.map((route) => (
                <Route key={route.path} path={route.path} element={route.element} />
              ))}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
      <Analytics />
      <SpeedInsights />
    </Router>
  );
}

export default App;
